export default __webpack_public_path__ + "static/media/exchange.4e3751c2.svg";